import React from "react";
import { Layout, theme } from "antd";
import logo from "../../../assets/logo-hor.svg";
import ProfileDropdown from "../components/ProfileDropdown";
import { Sling as Hamburger } from "hamburger-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const { Header } = Layout;

const MobileHeader = ({ open, setOpen }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Header
      style={{
        margin: "24px 16px 16px 16px",
        padding: "8px",
        background: colorBgContainer,
      }}
      className="flex justify-between items-center mediumShadow rounded-lg"
    >
      {" "}
      <motion.span whileTap={{ scale: 0.9 }} className="cursor-pointer">
        <Link to="/">
          <img src={logo} className="h-12" alt="logo" />
        </Link>
      </motion.span>
      <div className="flex items-center justify-center gap-2 ">
        <ProfileDropdown />
        <Hamburger toggled={open} toggle={() => setOpen(!open)} />
      </div>
    </Header>
  );
};

export default MobileHeader;
